/* eslint-disable react/jsx-props-no-spreading */
import { UserPermissions, UserType } from '@centecomm/portal-service';
import { FeatureConfiguration } from 'Core/Types/FeatureConfiguration';
import { IconProps } from 'Icons/IconProps';
import React from 'react';
import { RiShieldCheckLine } from 'react-icons/ri';
import { LoadingContent } from 'Shared/PageElements';
import { LaunchDarklyFlags } from 'utils/Hooks/LaunchDarkly/launchDarklyFlags';

const LazyComplianceBuilderPage = React.lazy(() => import('./Pages'));

const complianceBuilderConfiguration: FeatureConfiguration = {
    name: 'administrationFeature:system.complianceBuilder.title',
    navigationItem: {
        route: {
            text: 'administrationFeature:sidebar.system.complianceBuilder.title',
            url: '/compliance-builder',
            Icon: (props: IconProps) => <RiShieldCheckLine size={22} {...props} />,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyComplianceBuilderPage />
                </React.Suspense>
            ),
            tenantRoot: null,
        },
        // Visibility is governed entirely by `visibilityRule` -- this one is legacy/obsolete
        // See `docs/feature-visibility.md` for more details.
        isGloballyAccessible: true,
        permissions: [],
    },
    disableFeature: [],
    visibilityRule: {
        userType: UserType.OwnerOperator,
        permissions: {
            $all: [UserPermissions.ManageAdminConfig, UserPermissions.ViewCustomCompliance],
        },
        [LaunchDarklyFlags.ComplianceBuilder]: true,
    },
};

export default complianceBuilderConfiguration;
